import type { Column } from "@/components/DataTable";
import type { StoreCampaignRedemptionsRow } from "@/api/types";
import { formatCurrency, formatDate, formatNumber } from "@/lib/format";

/**
 * Store x campaign redemption table columns, shared by the ops campaign
 * dashboard and the retailer redemptions dashboard (same row shape).
 */
export const storeCampaignRedemptionColumns: Column<StoreCampaignRedemptionsRow>[] =
  [
    { header: "Store", cell: (r) => r.storeName, sortValue: (r) => r.storeName },
    {
      header: "Campaign",
      cell: (r) => r.campaignName,
      sortValue: (r) => r.campaignName,
    },
    {
      header: "Runs",
      cell: (r) => `${formatDate(r.startDate)} – ${formatDate(r.endDate)}`,
      // ISO dates sort correctly as strings.
      sortValue: (r) => r.startDate,
      csvValue: (r) => `${r.startDate} to ${r.endDate}`,
    },
    {
      header: "Redemptions",
      align: "right",
      cell: (r) => formatNumber(r.redemptions),
      sortValue: (r) => r.redemptions,
    },
    {
      header: "Fees earned by store",
      align: "right",
      cell: (r) => formatCurrency(r.earnedByStore),
      sortValue: (r) => r.earnedByStore,
    },
    {
      // Fees plus the reward value reimbursed to the store.
      header: "Total paid to store",
      align: "right",
      cell: (r) => formatCurrency(r.totalPaidToStore),
      sortValue: (r) => r.totalPaidToStore,
    },
  ];
